import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'tabs-dashboard',
    loadChildren: () => import('./tabs-dashboard/tabs-dashboard.module').then( m => m.TabsDashboardPageModule)
  },
  {
    path: 'tabs-leads',
    loadChildren: () => import('./tabs-leads/tabs-leads.module').then( m => m.TabsLeadsPageModule)
  },
  {
    path: 'tabs-upload',
    loadChildren: () => import('./tabs-upload/tabs-upload.module').then( m => m.TabsUploadPageModule)
  },
  {
    path: 'tabs-users',
    loadChildren: () => import('./tabs-users/tabs-users.module').then( m => m.TabsUsersPageModule)
  },
  {
    path: 'tabs-calendar',
    loadChildren: () => import('./tabs-calendar/tabs-calendar.module').then( m => m.TabsCalendarPageModule)
  },
  {
    path: 'tabs-settings',
    loadChildren: () => import('./tabs-settings/tabs-settings.module').then( m => m.TabsSettingsPageModule)
  },
  {
    path: 'users-add',
    loadChildren: () => import('./users-add/users-add.module').then( m => m.UsersAddPageModule)
  },
  {
    path: 'users-details',
    loadChildren: () => import('./users-details/users-details.module').then( m => m.UsersDetailsPageModule)
  },
  {
    path: 'leads-add',
    loadChildren: () => import('./leads-add/leads-add.module').then( m => m.LeadsAddPageModule)
  },
  {
    path: 'leads-detail',
    loadChildren: () => import('./leads-detail/leads-detail.module').then( m => m.LeadsDetailPageModule)
  },
  {
    path: 'appointment-assign',
    loadChildren: () => import('./appointment-assign/appointment-assign.module').then( m => m.AppointmentAssignPageModule)
  },
  {
    path: 'appointment-details',
    loadChildren: () => import('./appointment-details/appointment-details.module').then( m => m.AppointmentDetailsPageModule)
  },
  {
    path: 'tabs-manage-issues',
    loadChildren: () => import('./tabs-manage-issues/tabs-manage-issues.module').then( m => m.TabsManageIssuesPageModule)
  },
  {
    path: 'issues-edit',
    loadChildren: () => import('./issues-edit/issues-edit.module').then( m => m.IssuesEditPageModule)
  },
  {
    path: 'tabs-manage-labels',
    loadChildren: () => import('./tabs-manage-labels/tabs-manage-labels.module').then( m => m.TabsManageLabelsPageModule)
  },
  {
    path: 'tabs-manage-packages',
    loadChildren: () => import('./tabs-manage-packages/tabs-manage-packages.module').then( m => m.TabsManagePackagesPageModule)
  },
  {
    path: 'tabs-manage-channel',
    loadChildren: () => import('./tabs-manage-channel/tabs-manage-channel.module').then( m => m.TabsManageChannelPageModule)
  },
  {
    path: 'channel-edit',
    loadChildren: () => import('./channel-edit/channel-edit.module').then( m => m.ChannelEditPageModule)
  },
  {
    path: 'labels-edit',
    loadChildren: () => import('./labels-edit/labels-edit.module').then( m => m.LabelsEditPageModule)
  },
  {
    path: 'channel-add',
    loadChildren: () => import('./channel-add/channel-add.module').then( m => m.ChannelAddPageModule)
  },
  {
    path: 'issues-add',
    loadChildren: () => import('./issues-add/issues-add.module').then( m => m.IssuesAddPageModule)
  },
  {
    path: 'labels-add',
    loadChildren: () => import('./labels-add/labels-add.module').then( m => m.LabelsAddPageModule)
  },
  {
    path: 'tabs-manage-ads',
    loadChildren: () => import('./tabs-manage-ads/tabs-manage-ads.module').then( m => m.TabsManageAdsPageModule)
  },
  {
    path: 'tabs-manage-state-city',
    loadChildren: () => import('./tabs-manage-state-city/tabs-manage-state-city.module').then( m => m.TabsManageStateCityPageModule)
  },
  {
    path: 'ads-add',
    loadChildren: () => import('./ads-add/ads-add.module').then( m => m.AdsAddPageModule)
  },
  {
    path: 'ads-edit',
    loadChildren: () => import('./ads-edit/ads-edit.module').then( m => m.AdsEditPageModule)
  },
  {
    path: 'tabs-profile',
    loadChildren: () => import('./tabs-profile/tabs-profile.module').then( m => m.TabsProfilePageModule)
  },
  {
    path: 'calendar-detail',
    loadChildren: () => import('./calendar-detail/calendar-detail.module').then( m => m.CalendarDetailPageModule)
  },
  {
    path: 'maps',
    loadChildren: () => import('./maps/maps.module').then( m => m.MapsPageModule)
  },
  {
    path: 'labels-sub',
    loadChildren: () => import('./labels-sub/labels-sub.module').then( m => m.LabelsSubPageModule)
  },
  {
    path: 'tabs-manage-discounts',
    loadChildren: () => import('./tabs-manage-discounts/tabs-manage-discounts.module').then( m => m.TabsManageDiscountsPageModule)
  },
  {
    path: 'discounts-add',
    loadChildren: () => import('./discounts-add/discounts-add.module').then( m => m.DiscountsAddPageModule)
  },
  {
    path: 'discounts-edit',
    loadChildren: () => import('./discounts-edit/discounts-edit.module').then( m => m.DiscountsEditPageModule)
  },
  {
    path: 'tabs-manage-company',
    loadChildren: () => import('./tabs-manage-company/tabs-manage-company.module').then( m => m.TabsManageCompanyPageModule)
  },
  {
    path: 'company-add',
    loadChildren: () => import('./company-add/company-add.module').then( m => m.CompanyAddPageModule)
  },
  {
    path: 'company-edit',
    loadChildren: () => import('./company-edit/company-edit.module').then( m => m.CompanyEditPageModule)
  },
  {
    path: 'tabs-manage-promo-codes',
    loadChildren: () => import('./tabs-manage-promo-codes/tabs-manage-promo-codes.module').then( m => m.TabsManagePromoCodesPageModule)
  },
  {
    path: 'promo-add',
    loadChildren: () => import('./promo-add/promo-add.module').then( m => m.PromoAddPageModule)
  },
  {
    path: 'promo-edit',
    loadChildren: () => import('./promo-edit/promo-edit.module').then( m => m.PromoEditPageModule)
  },
  {
    path: 'leads-detail-quotation',
    loadChildren: () => import('./leads-detail-quotation/leads-detail-quotation.module').then( m => m.LeadsDetailQuotationPageModule)
  },
  {
    path: 'leads-detail-receipt',
    loadChildren: () => import('./leads-detail-receipt/leads-detail-receipt.module').then( m => m.LeadsDetailReceiptPageModule)
  },
  {
    path: 'tabs-finance-task',
    loadChildren: () => import('./tabs-finance-task/tabs-finance-task.module').then( m => m.TabsFinanceTaskPageModule)
  },
  {
    path: 'tabs-manage-places',
    loadChildren: () => import('./tabs-manage-places/tabs-manage-places.module').then( m => m.TabsManagePlacesPageModule)
  },
  {
    path: 'places-add',
    loadChildren: () => import('./places-add/places-add.module').then( m => m.PlacesAddPageModule)
  },
  {
    path: 'places-edit',
    loadChildren: () => import('./places-edit/places-edit.module').then( m => m.PlacesEditPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'finance-task-details',
    loadChildren: () => import('./finance-task-details/finance-task-details.module').then( m => m.FinanceTaskDetailsPageModule)
  },
  {
    path: 'sc-view-all',
    loadChildren: () => import('./sc-view-all/sc-view-all.module').then( m => m.ScViewAllPageModule)
  },
  {
    path: 'form-page',
    loadChildren: () => import('./form-page/form-page.module').then( m => m.FormPagePageModule)
  },
  {
    path: 'tabs-leads-warranty',
    loadChildren: () => import('./tabs-leads-warranty/tabs-leads-warranty.module').then( m => m.TabsLeadsWarrantyPageModule)
  },
  {
    path: 'tabs-manage-packages',
    loadChildren: () => import('./tabs-manage-packages/tabs-manage-packages.module').then( m => m.TabsManagePackagesPageModule)
  },
  {
    path: 'packages-add',
    loadChildren: () => import('./packages-add/packages-add.module').then( m => m.PackagesAddPageModule)
  },
  {
    path: 'packages-edit',
    loadChildren: () => import('./packages-edit/packages-edit.module').then( m => m.PackagesEditPageModule)
  },
  {
    path: 'tabs-manage-payment',
    loadChildren: () => import('./tabs-manage-payment/tabs-manage-payment.module').then( m => m.TabsManagePaymentPageModule)
  },
  {
    path: 'payment-add',
    loadChildren: () => import('./payment-add/payment-add.module').then( m => m.PaymentAddPageModule)
  },
  {
    path: 'payment-edit',
    loadChildren: () => import('./payment-edit/payment-edit.module').then( m => m.PaymentEditPageModule)
  },
  {
    path: 'tabs-calendar-event',
    loadChildren: () => import('./tabs-calendar-event/tabs-calendar-event.module').then( m => m.TabsCalendarEventPageModule)
  },
  {
    path: 'leads-detail-summary',
    loadChildren: () => import('./leads-detail-summary/leads-detail-summary.module').then( m => m.LeadsDetailSummaryPageModule)
  },
  {
    path: 'calendar-event-add',
    loadChildren: () => import('./calendar-event-add/calendar-event-add.module').then( m => m.CalendarEventAddPageModule)
  },  {
    path: 'tabs-leads-pending',
    loadChildren: () => import('./tabs-leads-pending/tabs-leads-pending.module').then( m => m.TabsLeadsPendingPageModule)
  },
  {
    path: 'tabs-leads-duplicate',
    loadChildren: () => import('./tabs-leads-duplicate/tabs-leads-duplicate.module').then( m => m.TabsLeadsDuplicatePageModule)
  },
  {
    path: 'tabs-leads-mylead',
    loadChildren: () => import('./tabs-leads-mylead/tabs-leads-mylead.module').then( m => m.TabsLeadsMyleadPageModule)
  },
  {
    path: 'tabs-leads-payment',
    loadChildren: () => import('./tabs-leads-payment/tabs-leads-payment.module').then( m => m.TabsLeadsPaymentPageModule)
  },
  {
    path: 'tabs-leads-tasklist',
    loadChildren: () => import('./tabs-leads-tasklist/tabs-leads-tasklist.module').then( m => m.TabsLeadsTasklistPageModule)
  },
  {
    path: 'tabs-leads-user',
    loadChildren: () => import('./tabs-leads-user/tabs-leads-user.module').then( m => m.TabsLeadsUserPageModule)
  },
  {
    path: 'calendar-event-update',
    loadChildren: () => import('./calendar-event-update/calendar-event-update.module').then( m => m.CalendarEventUpdatePageModule)
  },
  {
    path: 'tabs-leads-request',
    loadChildren: () => import('./tabs-leads-request/tabs-leads-request.module').then( m => m.TabsLeadsRequestPageModule)
  },
  {
    path: 'leads-detail-sof',
    loadChildren: () => import('./leads-detail-sof/leads-detail-sof.module').then( m => m.LeadsDetailSofPageModule)
  },
  {
    path: 'tabs-leads-sales-closed',
    loadChildren: () => import('./tabs-leads-sales-closed/tabs-leads-sales-closed.module').then( m => m.TabsLeadsSalesClosedPageModule)
  },
  {
    path: 'tabs-calendar-install',
    loadChildren: () => import('./tabs-calendar-install/tabs-calendar-install.module').then( m => m.TabsCalendarInstallPageModule)
  },
  {
    path: 'terms-and-condition',
    loadChildren: () => import('./terms-and-condition/terms-and-condition.module').then( m => m.TermsAndConditionPageModule)
  },
  {
    path: 'leads-detail-service',
    loadChildren: () => import('./leads-detail-service/leads-detail-service.module').then( m => m.LeadsDetailServicePageModule)
  },
  {
    path: 'tabs-leads-marketing',
    loadChildren: () => import('./tabs-leads-marketing/tabs-leads-marketing.module').then( m => m.TabsLeadsMarketingPageModule)
  },
  {
    path: 'tabs-manage-equipment',
    loadChildren: () => import('./tabs-manage-equipment/tabs-manage-equipment.module').then( m => m.TabsManageEquipmentPageModule)
  },
  {
    path: 'equipment-add',
    loadChildren: () => import('./equipment-add/equipment-add.module').then( m => m.EquipmentAddPageModule)
  },
  {
    path: 'equipment-edit',
    loadChildren: () => import('./equipment-edit/equipment-edit.module').then( m => m.EquipmentEditPageModule)
  },
  {
    path: 'tabs-leads-attended',
    loadChildren: () => import('./tabs-leads-attended/tabs-leads-attended.module').then( m => m.TabsLeadsAttendedPageModule)
  },
  {
    path: 'leads-detail-complaint',
    loadChildren: () => import('./leads-detail-complaint/leads-detail-complaint.module').then( m => m.LeadsDetailComplaintPageModule)
  },
  {
    path: 'leads-detail-email',
    loadChildren: () => import('./leads-detail-email/leads-detail-email.module').then( m => m.LeadsDetailEmailPageModule)
  },
  {
    path: 'leads-details-warranty',
    loadChildren: () => import('./leads-details-warranty/leads-details-warranty.module').then( m => m.LeadsDetailsWarrantyPageModule)
  },
  {
    path: 'tabs-leads-marketing-tasks',
    loadChildren: () => import('./tabs-leads-marketing-tasks/tabs-leads-marketing-tasks.module').then( m => m.TabsLeadsMarketingTasksPageModule)
  },
  {
    path: 'tabs-leads-marketing-media',
    loadChildren: () => import('./tabs-leads-marketing-media/tabs-leads-marketing-media.module').then( m => m.TabsLeadsMarketingMediaPageModule)
  },
  {
    path: 'tabs-manage-ads-platform',
    loadChildren: () => import('./tabs-manage-ads-platform/tabs-manage-ads-platform.module').then( m => m.TabsManageAdsPlatformPageModule)
  },
  {
    path: 'ads-platform-add',
    loadChildren: () => import('./ads-platform-add/ads-platform-add.module').then( m => m.AdsPlatformAddPageModule)
  },
  {
    path: 'ads-platform-edit',
    loadChildren: () => import('./ads-platform-edit/ads-platform-edit.module').then( m => m.AdsPlatformEditPageModule)
  },
  {
    path: 'tabs-leads-maintenance',
    loadChildren: () => import('./tabs-leads-maintenance/tabs-leads-maintenance.module').then( m => m.TabsLeadsMaintenancePageModule)
  }






];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
